import { Placeholder } from '@/tools/models/class-builder.models';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ed-class-subject-placeholder-item',
})
export default class EdClassSubjectPlaceholderItemComponent extends Vue {
  @Prop({ required: true }) readonly placeholder: Placeholder;
  @Prop() readonly subjectName: string;
  @Prop({ default: true }) readonly canEdit;
  @Prop({ default: false }) readonly canSelect;
  @Prop({ default: false }) readonly selected;
  @Prop({ required: false }) readonly isAbleToEdit;

  
  isSelected: boolean = false
  showTooltip: boolean = false

  get teacherName() {
    return this.placeholder?.teacher?.fullName || '';
  }

  get name() {
    return this.placeholder?.title || '';
  }

  get showTotalTimeTooltip() {
    return this.simulateSizePElementOverflow(this.placeholder.totalTime);
  }

  private simulateSizePElementOverflow(innerText: number): boolean {
    const pElement = document.createElement('p');
    pElement.style.fontSize = '14px';
    pElement.style.textOverflow = 'ellipsis';
    pElement.style.overflow = 'hidden';
    pElement.style.whiteSpace = 'nowrap';
    pElement.style.maxWidth = '35px';
    pElement.innerText = `(${innerText})`;
    document.firstElementChild.appendChild(pElement);
    const hasOverflow = pElement.offsetWidth < pElement.scrollWidth;
    document.firstElementChild.removeChild(pElement);
    
    return hasOverflow;
  }

  @Emit('onEditPlaceholderSelected')
  emitOnEditPlaceholderSelected() {
    return this.placeholder;
  }

  @Emit('onSeePlaceholderSelectedOnCalendar')
  emitOnSeePlaceholderSelectedOnCalendar() {
    return this.placeholder;
  }

  @Emit('onDeletePlaceholderSelected')
  emitOnDeletePlaceholderSelected() {
    return this.placeholder;
  }

  @Emit('onPlaceholderSelected')
  emitOnPlaceholderSelected() {
    return {
      placeholder: this.placeholder,
      isSelected: this.isSelected
    }
  }

  created() {
    this.setSelectProp()
    this.emitOnPlaceholderSelected()
  }

  mounted() {
    this.showTooltip = (this.$refs.title as HTMLDivElement).scrollHeight > (this.$refs.title as HTMLDivElement).clientHeight
  }
  
  setSelectProp() {
    this.isSelected = this.selected
    this.emitOnPlaceholderSelected()
  }

  @Watch('selected')
  onSelectedChanged() {
    this.setSelectProp()
  }
}